import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhoneDynamicIsland: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconPhoneDynamicIsland"><Path fillRule="evenodd" clipRule="evenodd" d="M6.75 23C5.7835 23 5 22.2165 5 21.25V2.75C5 1.7835 5.7835 1 6.75 1H17.25C18.2165 1 19 1.7835 19 2.75V21.25C19 22.2165 18.2165 23 17.25 23H6.75ZM10.75 3.49C10.3358 3.49 10 3.82579 10 4.24C10 4.65421 10.3358 4.99 10.75 4.99H13.25C13.6642 4.99 14 4.65421 14 4.24C14 3.82579 13.6642 3.49 13.25 3.49H10.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhoneDynamicIsland;
